/* eslint-disable-next-line no-restricted-imports */
import type { Id } from '@jane/shared/models';
import { useEcommApp } from '@jane/shared/providers';
import { isStore } from '@jane/shared/util';

import { selectStore } from '../customer/redux/store';
import { useCustomerSelector } from '../customer/selectors';

const GTI_STORE_IDS: Id[] = [
  2, 252, 253, 254, 255, 391, 392, 461, 596, 615, 616, 646, 725, 730, 756, 761,
  771, 773, 790, 834, 836, 874, 886, 887, 888, 1055, 1178, 1180, 1181, 1182,
  1236, 1253, 1263, 1317, 1338, 1340, 1341, 1342, 1343, 1344, 1474, 1475, 1497,
  1501, 1512, 1531, 1544, 1545, 1547, 1548, 1549, 1550, 1551, 1552, 1575, 1589,
  1718, 1812, 1867, 1885, 1961, 2040, 2252, 2265, 2266, 2350, 2351, 2446, 2517,
  2525, 2531, 2607, 2817, 2863, 2901, 3230, 3404, 3405, 3406, 3416, 3417, 3422,
  3466, 3467, 3468, 3469, 3542, 3543, 3579, 3717, 3936, 4018, 4049, 4050, 4052,
  4053, 4061, 4098, 4439, 4440, 4631, 4632, 4633, 4634, 4635, 4636, 4637, 4638,
  4970, 5077, 5102, 5202, 5205, 5233, 5266, 5267, 5268, 5269, 5270, 5383, 5417,
  5418, 5419, 5420, 5421, 5422, 5423, 5424, 5425, 5426, 5427, 5428, 5429, 5476,
  5477, 5478, 5486, 5550, 5624, 5653, 5800, 5907, 5960, 5964, 6011, 6012, 6013,
  6014, 6015, 6056, 6057, 6086, 6115, 6121, 6128,
];

export const useDisplayGTITerms = () => {
  const { store } = useCustomerSelector(selectStore);
  const { appMode } = useEcommApp();

  return (
    appMode === 'whiteLabel' &&
    isStore(store) &&
    GTI_STORE_IDS.includes(store.id)
  );
};
